import { useEffect, useState } from 'preact/hooks';
import { getApiBaseUrl } from '../config.ts';
import type { ProPlanOptions } from '../lib/pro-plan-pricing.ts';

export type ProPlanOptionsState =
  | { status: 'loading' }
  | { status: 'loaded'; data: ProPlanOptions }
  | { status: 'error' };

// Fetches the live Pro plan prices for the /pricing page. www ships no
// query client (see App.tsx) — a plain fetch-in-effect matches its
// zero-dependency posture. GetProPlanOptions is anonymous and its response
// is cached in-process on the API for 5 minutes, so there's no need to
// cache client-side too; each page load gets one request.
export function useProPlanOptions(): ProPlanOptionsState {
  const [state, setState] = useState<ProPlanOptionsState>({ status: 'loading' });

  useEffect(() => {
    let canceled = false;

    fetch(`${getApiBaseUrl()}/api/getProPlanOptions/v1`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({})
    })
      .then((response) => {
        if (!response.ok) throw new Error(`getProPlanOptions/v1 responded ${response.status}`);
        return response.json();
      })
      .then((body: { data: ProPlanOptions }) => {
        if (!canceled) setState({ status: 'loaded', data: body.data });
      })
      .catch(() => {
        if (!canceled) setState({ status: 'error' });
      });

    return () => {
      canceled = true;
    };
  }, []);

  return state;
}
